"use client";

import { useRef, useState, useActionState, useEffect } from "react";
import { search } from "@/actions/search";
import { SearchResult } from "@/lib/types";
import Form from "next/form";
import { Button } from "@/components/actions/Button";

interface SearchBarProps {
  onResultsChange: (results: SearchResult[]) => void;
}

export default function SearchBar({ onResultsChange }: SearchBarProps) {
  const [formState, action, pending] = useActionState(search, {
    results: [],
  });

  const [query, setQuery] = useState("");
  const [type, setType] = useState("all");
  const formRef = useRef<HTMLFormElement>(null);

  useEffect(() => {
    if (formState.results) {
      onResultsChange(formState.results);
    }
  }, [formState.results]);

  return (
    <div className="container mx-auto mb-8">
      <Form
        ref={formRef}
        action={action}
        className="flex  w-full mx-auto mb-8 gap-8 items-center"
      >
        <div className="flex items-center gap-0 min-w-[85%]">
          <input
            type="text"
            name="query"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="What are you looking for?"
            className="flex-1 min-w-[85%] px-8 py-5 border border-gray-300 rounded-4xl focus:outline-none focus:ring-2 focus:ring-gold text-black"
            required
            autoFocus
          />
          <select
            name="type"
            value={type}
            onChange={(e) => setType(e.target.value)}
            className="flex-1 w-auto px-8 py-5 border border-gray-300 rounded-4xl focus:outline-none focus:ring-2 focus:ring-gold text-black"
          >
            <option value="all">All</option>
            <option value="webpage">Pages</option>
            <option value="pdf">Resources</option>
          </select>
        </div>
        <input type="hidden" name="limit" value="10" />
        <Button
          type="submit"
          disabled={pending || !query.trim()}
          variant="secondary"
        >
          {pending ? "Searching..." : "Search"}
        </Button>
      </Form>
    </div>
  );
}
